import React, { useState, useRef } from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faFolderOpen,
    faChevronDown,
    faChevronUp,
    faSearch
}
from "@fortawesome/free-solid-svg-icons";

import { OMNISCAN_BLUE }
from "../../../constants/colors";

export default function FolderForagerHeader(
{
    directory,
    documentCount = 0,
    searchText = "",
    onSearchChange,
	onClassificationClick
})
{
    const [expanded, setExpanded] = useState(true);
	
	
	const [position, setPosition] = useState({
	    x: window.innerWidth / 2 - 360,
	    y: 16
	});

	const dragging = useRef(false);
	const dragOffset = useRef({ x: 0, y: 0 });

    const blueGradient =
        `linear-gradient(
            180deg,
            #7fc9ff 0%,
            ${OMNISCAN_BLUE} 100%
        )`;
		
		
		function handleMouseDown(e)
		{
		    dragging.current = true;

		    dragOffset.current =
		    {
		        x: e.clientX - position.x,
		        y: e.clientY - position.y
		    };

		    document.addEventListener("mousemove", handleMouseMove);
		    document.addEventListener("mouseup", handleMouseUp);
		}

		function handleMouseMove(e)
		{
		    if (!dragging.current)
		        return;

		    setPosition(
		    {
		        x: e.clientX - dragOffset.current.x,
		        y: e.clientY - dragOffset.current.y
		    });
		}

		function handleMouseUp()
		{
		    dragging.current = false;

		    document.removeEventListener("mousemove", handleMouseMove);
		    document.removeEventListener("mouseup", handleMouseUp);
		}

    return (

        <div
            style={{

                position: "fixed",

				left: position.x,

				top: position.y,

                width: "720px",

                background: "rgba(255,255,255,.22)",

                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",

                border: "1px solid rgba(255,255,255,.28)",

                borderRadius: "20px",

                boxShadow:
                    "0 10px 26px rgba(0,0,0,.14)",

                overflow: "hidden",

                transition: "all .35s ease",

                zIndex: 450

            }}
        >

            {/* Header */}

            <div
				onMouseDown={handleMouseDown}
                style={{

                    display: "flex",

                    alignItems: "center",

                    padding: "12px 18px",
					cursor: "move",
					   userSelect: "none"

                }}

            >

                {/* Folder */}

                <div

                    style={{

                        display: "flex",

                        alignItems: "center",

                        flex: 1

                    }}

                >

                    <FontAwesomeIcon

                        icon={faFolderOpen}

                        style={{

                            color: OMNISCAN_BLUE,

                            fontSize: "18px"

                        }}

                    />

                    <div
                        style={{
                            marginLeft: "12px"
                        }}
                    >

                        <div

                            style={{

                                fontSize: "18px",

                                fontWeight: 700,

                                color: "#222",

                                lineHeight: 1.1

                            }}

                        >

                            {

                                directory
                                    ?
                                    directory.name
                                    :
                                    "Documents"

                            }

                        </div>

                      

                    </div>

                </div>

                {/* Count */}

                <div

                    style={{

                        display: "flex",

                        alignItems: "center",

                        gap: "10px"

                    }}

                >

                    <div

                        style={{

                            background: blueGradient,

                            color: "white",

                            borderRadius: "8px",

                            padding: "6px 12px",

                            fontWeight: 700,

                            fontSize: "13px",

                            minWidth: "60px",

                            textAlign: "center"

                        }}

                    >

                        {documentCount}

                    </div>

                    <div

                        style={{

                            color: "#666",

                            fontSize: "12px"

                        }}

                    >

                        Docs

                    </div>

                    <FontAwesomeIcon

                        icon={
                            expanded
                                ?
                                faChevronUp
                                :
                                faChevronDown
                        }

                        onClick={() =>
                            setExpanded(!expanded)
                        }

                        style={{

                            cursor: "pointer",

                            color: "#666",

                            fontSize: "13px",

                            marginLeft: "6px"

                        }}

                    />

                </div>

            </div>

            {/* Search */}

			<div
			    style={{
			        padding: "0 18px 14px 18px"
			    }}
			>

			    <div
			        style={{
			            display: "flex",
			            alignItems: "center",
			            gap: "10px"
			        }}
			    >

			        {/* Search */}

			        <div
			            style={{
			                display: "flex",
			                alignItems: "center",

			                flex: 1,

			                background:
			                    "rgba(255,255,255,.32)",

			                border:
			                    "1px solid rgba(255,255,255,.28)",

			                borderRadius: "18px",

			                padding: "0 14px",

			                height: "38px"
			            }}
			        >

			            <FontAwesomeIcon
			                icon={faSearch}
			                style={{
			                    color: OMNISCAN_BLUE,
			                    fontSize: "13px"
			                }}
			            />

			            <input

			                value={searchText}

			                onChange={
			                    e =>
			                        onSearchChange(
			                            e.target.value
			                        )
			                }

			                placeholder="Search documents..."

			                style={{

			                    flex: 1,

			                    marginLeft: "10px",

			                    border: "none",

			                    outline: "none",

			                    background: "transparent",

			                    fontSize: "13px",

			                    color: "#222"

			                }}

			            />

			        </div>

			        {/* Classification Button */}

			        <div

			            onClick={onClassificationClick}

			            style={{

			                display: "flex",

			                alignItems: "center",

			                gap: "8px",

			                padding: "0 16px",

			                height: "38px",

			                borderRadius: "18px",

			                cursor: "pointer",

			                background:
			                    "linear-gradient(180deg,#2f3339 0%,#1c1f24 100%)",

			                color: "white",

			                border:
			                    "1px solid rgba(255,255,255,.08)",

			                boxShadow:
			                    "0 6px 16px rgba(0,0,0,.22)",

			                transition: "all .18s ease"

			            }}

			            onMouseEnter={e =>
			            {
			                e.currentTarget.style.transform =
			                    "translateY(-1px)";

			                e.currentTarget.style.boxShadow =
			                    "0 10px 22px rgba(0,0,0,.28)";
			            }}

			            onMouseLeave={e =>
			            {
			                e.currentTarget.style.transform =
			                    "translateY(0)";

			                e.currentTarget.style.boxShadow =
			                    "0 6px 16px rgba(0,0,0,.22)";
			            }}

			        >

			            <FontAwesomeIcon
			                icon={faFolderOpen}
			                style={{
			                    color: OMNISCAN_BLUE
			                }}
			            />

			            <span
			                style={{
			                    fontSize: "12px",
			                    fontWeight: 600
			                }}
			            >
			                Classifications
			            </span>

			        </div>

			    </div>

			</div>

        </div>

    );

}